import { makeAutoObservable } from 'mobx'
import { restaurantConfig, productMobx, restaurantCenter, RESTAURANT_EVENT, productExtMobx } from '..'
import productCenter from './center/productCenter'
import { sortBy } from '@dt/fe-utils/dist/lodash'
import { ddayjs } from '@dt/fe-utils'

// 餐品排序
export const sortPoucts = (categoryNo: string | undefined, products: IViewProduct[], sortSoldout?: boolean) => {
  if (categoryNo === restaurantConfig.posAllCategoriesNo) {
    return products
  }
  // 为了全菜单和时段菜单的排序一致性，使用id作为默认排序
  products = sortBy(products, 'id')
  // products.sort((a, b) => a.modifyTime < b.modifyTime ? 1 : a.modifyTime === b.modifyTime ? 0 : -1)
  if (categoryNo && productExtMobx.sorts.products && productExtMobx.sorts.products[categoryNo]) {
    const productSortMap: any = {}
    productExtMobx.sorts.products[categoryNo].forEach((d, i) => (productSortMap[d] = i))
    // 排序的数据可能并不完整（有新增的餐品等，这时需要一个辅助变量来保证每次排序是可控的）
    products.sort((a, b) => (productSortMap[a.no] !== undefined ? productSortMap[a.no] : a.id) * 100000 - (productSortMap[b.no] !== undefined ? productSortMap[b.no] : b.id) * 100000)
  }
  if (sortSoldout) {
    products = sortBy(products, (product) => product.disable ? 1 : 0)
  }
  return products
}

class Menu {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
    // 当前监听到菜单可用度变化的时候 再次判断可用度
    restaurantCenter.on(RESTAURANT_EVENT.MENU_AVAILABLE, () => {
      this.judgeAvailable()
    })
    // 根据模式不同选择，自动选择分类
    restaurantCenter.on(RESTAURANT_EVENT.MENU_END, () => {
      if (restaurantConfig.displayMode !== 'waterfall' && this.categories.length && (!this.selectCategoryNo || !this.categories.find(categroy => categroy.no === this.selectCategoryNo))) {
        this.selectCategory(this.categories[0].no)
      }
      // 如果门店切换后选择的分类no清空
      // if (restaurantConfig.displayMode === 'waterfall' && this.selectCategoryNo) {
      //   this.selectCategory()
      // }
      if (this.openSoldoutHidden === 1 && this.openSoldout === 1) {
        this.initOpenSoldout()
      }
    })
    restaurantCenter.on(RESTAURANT_EVENT.CONFIG_DISPLAYMODE_UPDATED, (displayMode: 'category' | 'waterfall' | 'classic' | 'list') => {
      if (displayMode === 'waterfall' && this.selectCategoryNo) {
        this.selectCategory()
      }
    })
    restaurantCenter.on(RESTAURANT_EVENT.MENU_OPEN_SOLDOUT, ({
      openFoldSoldout,
      openSoldout,
      openSoldoutHidden,
      openFoldSoldoutScale,
      type
    }: {
      openSoldout: 0 | 1;
      openSoldoutHidden: 0 | 1;
      openFoldSoldout: 0 | 1;
      openFoldSoldoutScale: 0 | 1;
      type: 'store' | 'brand';
    }) => {
      if (type === 'store') {
        if (openFoldSoldout === 0 && openSoldoutHidden === 1) {
          if ((openSoldout !== this.openSoldout || openSoldoutHidden !== this.openSoldoutHidden) && openSoldout === 1 && openSoldoutHidden === 1) {
            this.initOpenSoldout()
          }
          this.setOpenSoldout(openSoldout)
          this.setOpenSoldoutHidden(openSoldoutHidden)
          if (openSoldoutHidden === 1 && !openSoldout) {
            this.setIsOpenSoldout(!!openSoldoutHidden)
          }
        }
      } else if (openFoldSoldout === 1 && openSoldoutHidden === 0) {
        this.setOpenFoldSoldout(openFoldSoldout)
      }
      this.setOpenFoldSoldoutScale(openFoldSoldoutScale)
    })
    // 如果重置购物车时则重置搜索关键词
    restaurantCenter.on(RESTAURANT_EVENT.CART_RESET, () => {
      if (this.searchKey !== null) {
        this.setSearchKey(null)
      }
    })
  }

  /** 菜单正在加载中 */
  isLoading = false

  /** 菜单加载失败 */
  isError = false

  /** 菜单生效的range */
  range: {
    begin: string;
    end: string;
  } = {
    begin: '000000',
    end: '240000'
  }

  /** 当前菜单是否可用 */
  isAvailable = true

  /** 下一次刷新的时间点 */
  nextRefreshTime = 0

  /** 延迟滚动加载图片支持 */
  imgLoadingMap: { [no: string]: boolean } = {}

  /** 当前选中的菜单no */
  selectCategoryNo?: string

  /** 搜索的关键词，注意区别null 和 ''，用于标识是否在查询状态 */
  searchKey: string | null = null

  /** 是否开启售罄展示 */
  openSoldout: 0 | 1 = 0

  /** 是否开启直接售罄 */
  openSoldoutHidden: 0 | 1 = 0

  /** 菜单隐藏售罄商品控制 */
  isOpenSoldout: boolean = false

  /** 可触发售罄 */
  canOpenSoldout: boolean = false

  /** 开启折叠收起售罄 */
  openFoldSoldout: 0 | 1 = 0

  /** 开启折叠收起规格加料售罄 */
  openFoldSoldoutScale: 0 | 1 = 0

  /** 菜单折叠收起售罄商品控制 key可以是categoryNo | all, 值为true为展开 */
  foldSoldoutMap: { [key: string]: boolean } = {}

  /** 显示菜单刷新倒计时 */
  showMenuRefreshTip: Record<TChannel, {
    status: boolean;
    time: number;
    currentTime: number;
  }> = {
    mobile: { status: false, time: 0, currentTime: 0 },
    pos: { status: false, time: 0, currentTime: 0 },
    '3rdDelivery': { status: false, time: 0, currentTime: 0 },
    meituan: { status: false, time: 0, currentTime: 0 },
    eleme: { status: false, time: 0, currentTime: 0 },
    selfDelivery: { status: false, time: 0, currentTime: 0 },
    kiosk: { status: false, time: 0, currentTime: 0 },
    buyTogether: { status: false, time: 0, currentTime: 0 },
    callPos: { status: false, time: 0, currentTime: 0 },
    groupMeal: { status: false, time: 0, currentTime: 0 },
    deliverect: { status: false, time: 0, currentTime: 0 },
    douyin: { status: false, time: 0, currentTime: 0 },
  }

  /** 折叠控制显示隐藏分类下的售罄餐品 */
  categoryNoTofoldSoldout: { [no: string]: boolean } = {}

  /** 分类排序map */
  get categorySortMap () {
    if (productExtMobx.sorts.categories.length) {
      const categorySortMap: any = {}
      productExtMobx.sorts.categories.forEach((d, i) => (categorySortMap[d] = i))
      return categorySortMap
    } else {
      return {}
    }
  }

  /** 聚合后的餐品展示分类的数据 */
  get categories () {
    const categorySortMap = this.categorySortMap
    const menu = productMobx.categories.map(category => {
      return { ...category, products: (productMobx.categoryNoToViewProductsMap[category.no] || []).filter(product => (this.isOpenSoldout ? product.saleCnt !== 0 : true) && product.isShowInMenu) } as IMenuCategory
    })
    restaurantConfig.posAllCategories && menu?.length && menu.unshift({
      no: restaurantConfig.posAllCategoriesNo,
      name: '',
      products: [],
    } as IMenuCategory)
    // 使用ext排序规则
    if (productExtMobx.sorts.categories.length) {
      menu.sort((a, b) => (categorySortMap[a.no] || 0) * 1000 - (categorySortMap[b.no] || 0) * 1000)
      return menu
    }
    // 隐藏时价餐品
    if (restaurantConfig.hideOpenPriceProduct) {
      menu.forEach(m => (m.products = m.products.filter(p => !p.isOpenPrice)))
    }
    if (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') {
      const fmenu = menu.filter(menu => menu.products.length)
      if (restaurantConfig.displayMode === 'classic' || restaurantConfig.displayMode === 'waterfallCategory' || restaurantConfig.displayMode === 'list') {
        // 处理默认排序
        return fmenu.map(m => ({ ...m, products: m.products.sort((a, b) => (b.sortInCategory ? b.sortInCategory[m.no] : 0) - (a.sortInCategory ? a.sortInCategory[m.no] : 0)) }))
      } else {
        return fmenu
      }
    } else {
      return menu
    }
  }

  /** 聚合后的餐品展示餐品的数据 */
  get products () {
    // 如果是瀑布流则不指定分类显示全餐品，而category类型不指定则显示默认第一个分类
    let products: IViewProduct[] = []
    // 餐品排序
    const sortPoucts = (categoryNo: string | undefined, products: IViewProduct[]) => {
      if (categoryNo === restaurantConfig.posAllCategoriesNo) {
        return products
      }
      // 为了全菜单和时段菜单的排序一致性，使用id作为默认排序
      products = sortBy(products, 'id')
      // products.sort((a, b) => a.modifyTime < b.modifyTime ? 1 : a.modifyTime === b.modifyTime ? 0 : -1)
      if (categoryNo && productExtMobx.sorts.products && productExtMobx.sorts.products[categoryNo]) {
        const productSortMap: any = {}
        productExtMobx.sorts.products[categoryNo].forEach((d, i) => (productSortMap[d] = i))
        // 排序的数据可能并不完整（有新增的餐品等，这时需要一个辅助变量来保证每次排序是可控的）
        products.sort((a, b) => (productSortMap[a.no] !== undefined ? productSortMap[a.no] : a.id) * 100000 - (productSortMap[b.no] !== undefined ? productSortMap[b.no] : b.id) * 100000)
      }
      return products
    }
    if (restaurantConfig.displayMode === 'category' || restaurantConfig.displayMode === 'waterfall') {
      if (restaurantConfig.displayMode === 'category' && this.searchKey !== null) {
        if (this.searchKey === '') {
          return []
        } else {
          return productMobx.viewProducts.filter(product => ~product.pinyin?.toLowerCase().indexOf(this.searchKey?.toLowerCase() as string))
        }
      } else if (this.selectCategoryNo) {
        if (this.selectCategoryNo === restaurantConfig.posAllCategoriesNo) {
          this.categories.forEach(item => {
            if (item.no !== restaurantConfig.posAllCategoriesNo) {
              let itemProducts = item.products.filter(product => !products.find(item => product.no === item.no))
              products.push(...sortPoucts(item.no, itemProducts))
            }
          })
        } else {
          products = this.categories.find(category => category.no === this.selectCategoryNo)?.products || []
        }
      } else {
        if (restaurantConfig.displayMode === 'waterfall') {
          products = productMobx.viewProducts
        } else {
          products = this.categories.length ? this.categories[0].products : []
        }
      }
    } else {
      products = productMobx.viewProducts
    }
    // 过滤掉不单独售卖(套餐内餐品)餐品
    products = products.filter((product: any) => product.isNotSingleInCombo && product.isShowInMenu)
    // 隐藏时价餐品
    if (restaurantConfig.hideOpenPriceProduct) {
      products = products.filter((product: any) => !product.isOpenPrice)
    }
    // 排序规则
    if (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') {
      return products
    } else {
      return sortPoucts(this.selectCategoryNo, products)
    }
  }

  /** 根据分类排序获得全量餐品 */
  get getProductsForSortCategory () {
    const products: IViewProduct[] = []
    this.categories.forEach(item => {
      products.push(...sortPoucts(item.no, item.products.map((product) => {
        return {
          ...product,
          categoryNo: item.no
        }
      }), restaurantConfig.downSoldoutProduct))
    })
    return products
  }

  /** 查询之后的结果 */
  get searchedProducts (): IViewProduct[] | null {
    if (this.searchKey === null) {
      return null
    } else if (this.searchKey === '') {
      return []
    } else {
      return productMobx.viewProducts.filter((product: any) => product.isNotSingleInCombo && product.isShowInMenu).filter(product => ~product.name.indexOf(this.searchKey || '') || ~product.pinyin?.toLowerCase().indexOf(this.searchKey?.toLowerCase() as string))
    }
  }

  /** 初始化菜单倒计时 */
  initShowMenuTip (refreshInfo: { status: boolean; time: number; currentTime: number }, channel: TChannel) {
    const data = this.showMenuRefreshTip?.[channel]
    if (data) {
      // 防止5分钟内有重复小菜单【秒杀活动的餐品】
      if (data.status) return
      this.showMenuRefreshTip = {
        ...this.showMenuRefreshTip,
        [channel]: {
          ...data,
          ...refreshInfo
        }
      }
    }
  }

  /** 菜单更新倒计时 */
  switchShowMeuuTip (refreshInfo: { status?: boolean; time?: number; currentTime?: number }) {
    this.showMenuRefreshTip = {
      ...this.showMenuRefreshTip,
      [productMobx.channel]: {
        ...this.showMenuRefreshTip[productMobx.channel],
        ...refreshInfo
      }
    }
  }

  /** 智能售罄 => 初始化售罄 */
  initOpenSoldout () {
    const soldoutLimitNum = 20 // 售罄出发阈值 售罄商品占全部商品的 {{20}}%
    let products = this.products
    let totleNum = products.length
    let soldoutNum = products.filter(item => item.saleCnt === 0).length
    this.canOpenSoldout = this.openSoldout === 1 && this.openSoldoutHidden === 1 && Boolean((soldoutNum / totleNum * 100 >= soldoutLimitNum) && products.length)
    this.isOpenSoldout = false
  }

  /** 智能售罄 => 控制折叠售罄餐品 */
  setFoldSoldoutMap (key: string) {
    this.foldSoldoutMap = {
      ...this.foldSoldoutMap,
      [key]: !this.foldSoldoutMap?.[key]
    }
  }

  /** 选择分类 */
  selectCategory (category?: ICategory | string) {
    this.selectCategoryNo = (typeof category === 'string' || typeof category === 'undefined') ? category : category.no
  }

  /** 设置下一次刷新的时间 */
  setNextRefreshTime (nextRefreshTime: number) {
    this.nextRefreshTime = nextRefreshTime
    restaurantCenter.clearDelay(RESTAURANT_EVENT.MENU_WILL_UPDATE)
    // 同步make一个延迟时间
    if (nextRefreshTime) {
      // 提醒的剩余时间(ms)
      const now = Date.now()
      // 如果下一个刷新点在后面就不再处理
      if (nextRefreshTime < now) {
        return
      }
      let willTime = nextRefreshTime - restaurantConfig.earlyTime - Date.now()
      willTime = willTime > 0 ? willTime : 0
      // 事件传入的值是实际要将要刷新的剩余时间（ms）
      const remainTime = willTime ? restaurantConfig.earlyTime : nextRefreshTime - Date.now()
      restaurantCenter.delay(nextRefreshTime - restaurantConfig.earlyTime - Date.now(), RESTAURANT_EVENT.MENU_WILL_UPDATE, remainTime)
      // 菜单主动刷新事件，加入2s延时
      restaurantCenter.clearDelay(RESTAURANT_EVENT.MENU_REFRESH)
      restaurantCenter.delay(nextRefreshTime - Date.now() + 2000, RESTAURANT_EVENT.MENU_REFRESH)
    }
  }

  /** 设置当前菜单是否可用 */
  setIsAvailable (isAvailable: boolean) {
    this.isAvailable = isAvailable
  }

  /** 判断可用菜单 */
  judgeAvailable () {
    // 如果是预约的时间，则用预约的时间来判断
    const presentTime = productCenter.appointmentTime ? productCenter.appointmentTime.replace(':', '') + '00' : ddayjs().format('HHmmss')
    this.isAvailable = parseInt(this.range.begin) <= parseInt(presentTime) && parseInt(this.range.end) >= parseInt(presentTime)
    // 当前只处理一种case 菜单的begin时间未到, 切在空档期
    if (!this.isAvailable) {
      const offsetTime = parseInt(this.range.begin) - parseInt(presentTime)
      restaurantCenter.clearDelay(RESTAURANT_EVENT.MENU_AVAILABLE)
      if (offsetTime > 0) {
        // TODO 可能需要控制力度 1126 -> 2s
        restaurantCenter.delay(ddayjs(this.range.begin, 'HHmmss').valueOf() - ddayjs(presentTime, 'HHmmss').valueOf() + 2000, RESTAURANT_EVENT.MENU_AVAILABLE)
      } else {
        // 处理扩0点的case

      }
    } else {
      restaurantCenter.clearDelay(RESTAURANT_EVENT.MENU_AVAILABLE)
    }
  }

  /** 设置图片延迟加载以加载的数据 */
  setImgLoading (no: string) {
    this.imgLoadingMap[no] = true
  }

  /** 设置菜单的使用周期 */
  setRange (range: {
    begin: string; // HHmmss
    end: string; // HHmmss
  }) {
    this.range = range
    // 处理菜单的可用性
    this.judgeAvailable()
  }

  /** 设置菜单加载状态 */
  setIsLoading (isLoading: boolean) {
    this.isLoading = isLoading
    if (isLoading) {
      this.isError = false
    }
  }

  /** 设置菜单加载错误状态 */
  setIsError (isError: boolean) {
    this.isError = isError
    this.isLoading = false
  }

  /** 设置搜索关键词 */
  setSearchKey (searchKey: string | null) {
    this.searchKey = searchKey
  }

  /** 顾客是否可以屏蔽售罄餐品 */
  setOpenSoldout (openSoldout: 0 | 1) {
    this.openSoldout = openSoldout
  }

  /** 装修配置直接隐藏售罄餐品 */
  setOpenSoldoutHidden (openSoldoutHidden: 0 | 1) {
    this.openSoldoutHidden = openSoldoutHidden
  }

  /** 显示售罄弹窗 */
  setCanOpenSoldout (canOpenSoldout: boolean) {
    this.canOpenSoldout = canOpenSoldout
  }

  /** 控制隐藏售罄餐品的直接方法，菜单过滤售罄 */
  setIsOpenSoldout (isOpenSoldout: boolean) {
    this.isOpenSoldout = isOpenSoldout
  }

  /** 装修配置直接隐藏售罄餐品 */
  setOpenFoldSoldout (openFoldSoldout: 0 | 1) {
    this.openFoldSoldout = openFoldSoldout
  }

  /** 装修配置直接隐藏售罄加料规格 */
  setOpenFoldSoldoutScale (openFoldSoldoutScale: 0 | 1) {
    this.openFoldSoldoutScale = openFoldSoldoutScale
  }

  /** 售罄餐品折叠 */
  setCategoryNoTofoldSoldout (categoryNo: string) {
    this.categoryNoTofoldSoldout = {
      ...this.categoryNoTofoldSoldout,
      [categoryNo]: !this.categoryNoTofoldSoldout[categoryNo]
    }
  }
}

export default new Menu()
